<ul class="wpdh-pager">
  <li><button class="wpdh-pager__button wpdh-pager__button--previous" (click)="previousPage()">Previous</button></li>
  <li class="wpdh-pager__excess-icon" [class.is-active]="lowerLimit > 0">...</li>
  @for (page of pager; track page) {
  <li>
    @if (pager.indexOf(page) >= lowerLimit && pager.indexOf(page) < upperLimit) {
    <button class="wpdh-pager__button" [class.is-active]="page === activePage" (click)="updatePage(page)">
      {{ page.label }}
    </button>
    }
  </li>
  }
  <li class="wpdh-pager__excess-icon" [class.is-active]="upperLimit < pager.length">...</li>
  <li><button class="wpdh-pager__button wpdh-pager__button--next" (click)="nextPage()">Next</button></li>
</ul>
